module.exports = __webpack_public_path__ + "static/media/fjc.99fb7f50.svg";